import { render } from "./HorseCard.vue?vue&type=template&id=00e87686"
import script from "./HorseCard.vue?vue&type=script&lang=js"
export * from "./HorseCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/packages/jlhorses_theme/vueproject/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__